module.exports = __webpack_public_path__ + "img/微压深炖锅.138d4bb6.png";